import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

// Custom rounded bar shape
const RoundedBar = (props) => {
  const { x, y, width, height, fill } = props;
  return (
    <rect x={x} y={y} width={width} height={height} rx={8} ry={8} fill={fill} />
  );
};

const HourlyCheckChart = ({ data }) => {
  console.log("datasadsad", data);
  if (!data || !data.hourly_distribution) return null;

  // Format data for Recharts
  const chartData = data.hourly_distribution.map((item) => ({
    hour: `${item.hour}:00`,
    CheckIn: item.total_checkin,
    CheckOut: item.total_checkout,
  }));

  return (
    <div
      style={{
        height: "400px",
        background: "#FFF",
        padding: "50px 30px",
        borderRadius: "15px",
        border: "1px solid #CDCDCD",
        boxShadow: "2px 4px 5px #DDD",
      }}
    >
      {/* <h5 style={{ marginBottom: "20px" }}>Hourly Check-in / Check-out</h5> */}
      <hr />
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={chartData}
          margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
        >
          <XAxis
            dataKey="hour"
            label={{
              value: "Hour of Day",
              position: "insideBottom",
              dy: 10,
            }}
          />
          <YAxis
            allowDecimals={false}
            label={{
              value: "Count",
              angle: -90,
              position: "insideLeft",
            }}
          />
          <Tooltip />
          <Legend verticalAlign="top" height={36} />
          <Bar
            dataKey="CheckIn"
            fill="#00a86b"
            shape={<RoundedBar />}
            barSize={30}
          />
          <Bar
            dataKey="CheckOut"
            fill="#ff3c3c"
            shape={<RoundedBar />}
            barSize={30}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default HourlyCheckChart;
